import { Text, TypographyPage } from 'ui';

export default {
  letters: {
    i: {
      text: 'Enjoy and draw energy from being alone rather than from being around others.',
    },
    s: {
      text: 'Focus on logic and facts rather than concepts.',
    },
    f: {
      text: 'Place a weight on feelings and values rather than thoughts when making decisions.',
    },
    p: {
      text: 'Prefer spontaneity and flexibility over planning and organization.',
    },
  },
  persons: [
    {
      slug: 'west',
      name: 'Kanye West',
    },
    {
      slug: 'gaga',
      name: 'Lady Gaga',
    },
    {
      slug: 'beckham',
      name: 'David Beckham',
    },
  ],
  advantages: ['Principled', 'Problem-solving', 'Curious', 'Creativity'],
  disadvantages: [
    'Unpredictable',
    'Easily bored',
    'Lack of planning',
    'Too sensitive',
  ],
  aboutUsCards: [
    {
      color: 'orange',
      title: 'ISFP principles and motivations',
      text: "ISFPs are deeply principled, and these core values guide them through life. They have little tolerance for liars, cheaters, and hypocrites, but their hate for conflict and compassionate nature means they probably won’t express their distaste. They dislike drama and won’t sacrifice their morality for anything.",
    },
    {
      title: 'How ISFPs are perceived',
      color: 'red',
      text: 'ISFPs may come across as standoffish or aloof at first due to their introverted and quiet nature. However, their thirst for adventure means that they often find themselves in social settings, which is why they can actually be mistaken for extraverts initially. People generally perceive them as difficult to get to know, though and may think they are shy or mysterious.',
    },
    {
      color: 'mint',
      title: 'Popular ISFP hobbies',
      text: 'ISFPs’ adventurous nature means that they enjoy trying new hobbies but prefer to learn by doing rather than researching. They like anything creative or artistic and prefer their hobbies to be independent or in very small groups.',
    },
  ],
  aboutTypeDescription:
    'ISFP is one of 16 personality types. The test categorizes personalities based on a range of questions determining which four opposing traits a person tends towards extroversion vs. introversion, sensing vs. intuition, feeling vs. thinking, and judging vs. perceiving. ISFP stands for introverted (I), sensing (S), feeling (F), and perceiving (P). ISFPs tend to:',
  aboutTypeTextContent: (
    <TypographyPage dense>
      <Text>
        ISFPs enjoy life with cheerful, quiet enthusiasm and easily find beauty
        in their surroundings. Their love of aesthetics and artistic flair means
        you’ll often find them thriving in creative ventures.
      </Text>
      <Text>
        ISFPs are known as the “Adventurer” for their spontaneous and
        explorative nature. Their curiosity and zest for life keep them
        constantly seeking new experiences. ISFPs are easygoing and calm and
        known for being kind and compassionate with others. Their skills in
        perception mean they find it easy to understand others' unspoken
        thoughts and feelings, and they give logical and thoughtful advice.
      </Text>
    </TypographyPage>
  ),
};
